import { useEffect, useState } from "react";
import { io } from "socket.io-client";
import axiosInstance from "../pages/axiosInstance"; // ✅ Corrected path
import PostCard from "./PostCard";
import ActivityFeed from "./ActivityFeed";

const socket = io("http://localhost:5000");

const Home = () => {
  const [posts, setPosts] = useState([]);
  const [content, setContent] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [translations, setTranslations] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  // const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");

  const fetchPosts = async () => {
    try {
      setIsLoading(true);
      const res = await axiosInstance.get("/posts"); // ✅ Replaced axios
      setPosts(res.data);
    } catch (err) {
      console.error("Failed to fetch posts:", err);
      setError("Failed to load posts. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleCreatePost = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!content.trim()) {
      return setError("Post content cannot be empty.");
    }

    try {
      await axiosInstance.post("/posts", { content }); // ✅ Replaced axios + no need for manual headers
      setContent("");
      setSuccess("✅ Post shared successfully!");
    } catch (err) {
      const msg = err.response?.data?.message || "Something went wrong!";
      setError(msg);
    }
  };

  const handleTranslate = async (postId, text) => {
    try {
      const res = await axiosInstance.post("/translate", {
        text,
        targetLang: "hi",
      }); // ✅ Replaced axios
      setTranslations((prev) => ({
        ...prev,
        [postId]: res.data.translatedText,
      }));
    } catch (err) {
      console.error("Translation failed:", err);
    }
  };

  useEffect(() => {
    fetchPosts();

    socket.on("new_post", (newPost) => {
      setPosts((prev) => [newPost, ...prev]);
    });

    return () => {
      socket.off("new_post");
    };
  }, []);

  return (
    <div className="max-w-xl mx-auto mt-8 px-4">
      <h2 className="text-2xl font-bold mb-4">📢 Home Feed</h2>

      <ActivityFeed userId={userId} />

      {error && (
        <div className="bg-red-100 text-red-700 p-2 mb-2 rounded">
          ❌ {error}
        </div>
      )}
      {success && (
        <div className="bg-green-100 text-green-700 p-2 mb-2 rounded">
          {success}
        </div>
      )}

      <form onSubmit={handleCreatePost} className="mb-6 flex flex-col gap-2">
        <textarea
          value={content}
          onChange={(e) => setContent(e.target.value)}
          placeholder="What's on your mind?"
          className="p-3 border border-gray-300 rounded-md resize-none focus:outline-none focus:ring focus:ring-blue-400"
          rows="3"
        />
        <button
          type="submit"
          className="bg-blue-600 hover:bg-blue-700 text-white font-semibold p-2 rounded-lg transition"
        >
          🚀 Post
        </button>
      </form>

      {isLoading ? (
        <p className="text-center text-gray-500">⏳ Loading posts...</p>
      ) : posts.length === 0 ? (
        <p className="text-center text-gray-500 italic">No posts yet.</p>
      ) : (
        posts.map((post) => (
          <div key={post._id} className="mb-6">
            <PostCard post={post} refreshPosts={fetchPosts} />
            <button
              onClick={() => handleTranslate(post._id, post.content)}
              className="mt-2 text-sm text-blue-600 hover:underline"
            >
              🌐 Translate to Hindi
            </button>
            {translations[post._id] && (
              <div className="mt-1 text-sm text-gray-700 bg-gray-100 p-2 rounded">
                <strong>Translation:</strong> {translations[post._id]}
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
};

export default Home;
